module.exports = {
  domain: {
    desktop: "www.stg.use2.racing.fndlext.net",
    mobile: "www.stg.use2.racing.fndlext.net",
    talentPicks: "www.stg.use2.racing.fndlext.net/talent-picks/",
    accountWallet: "account.racing.fanduel.com",
    equibase: "equibase-store.tvg.com"
  },
  recaptchaID: "6LeIYBcqAAAAAE2wDhSub9Ic8oeidAiiUt4gYM4a",
  recaptchaIdNative: "6LfRQloqAAAAABY9v2RydlB10Lfgb5ODmvygHy3G"
};
